import React from 'react';

import Link from '../../components/Link';
import FAQs from '../../components/FAQs';

const Questions = [{
  question: 'What is included in the membership?',
  answer: 'The Exponent membership includes exclusive access to all of the course content, unlimited peer mock interviews, early access to AI interview features, our subscriber-only Slack channel, priority on our job referrals platform, and so much more! Our courses include detailed lessons, guides, videos, and frameworks to help you ace your interview. Browse our courses at tryexponent.com/courses.',
}, {
  question: 'What is included in the Exponent Slack Channel?',
  answer: 'The Exponent Slack Channel is a private community of tens of thousands of other Exponent members. Our Slack Channel has relevant, fresh information on acing interviews and recent interview experiences shared by candidates like yourself.',
}, {
  question: 'What are priority job referrals?',
  answer: (
    <span>
      As an Exponent member, you get priority in
      {' '}
      <Link className="text-indigo" href="/jobs/referrals" target="_blank">
        our job referral platform
      </Link>
      . This means anytime one of our 400+ referrers looks to refer candidates,
      you will be placed at the top of the list, and you get unlimited referral requests.
    </span>),
}, {
  question: 'Does my membership purchase include coaching?',
  answer: (
    <span>
      If you&rsquo;re interested in interview or career coaching, visit
      {' '}
      <Link className="text-indigo" href="/coaching" target="_blank">Coaching</Link>
      {' '}
      to learn more.
    </span>
  ),
}, {
  question: 'What is your renewal policy?',
  answer: (
    <span>
      Your Exponent membership will renew automatically. You can cancel your plan at
      any time before your renewal date by visiting the
      {' '}
      <Link className="text-indigo" href="/account" target="_blank">account page</Link>
      .
    </span>),
}, {
  question: 'I have a question not answered here.',
  answer: (
    <span>
      Check out our full
      {' '}
      <Link className="text-indigo" href="/support" target="_blank">FAQ list here</Link>
      , or send us an email at
      {' '}
      <Link className="text-indigo" href="mailto:support@tryexponent.com">support@tryexponent.com</Link>
      .
    </span>),
}];

const QuestionsWithRefund = [{
  question: 'What is included in the membership?',
  answer: 'The Exponent membership includes exclusive access to all of the course content, unlimited peer mock interviews, early access to AI interview features, our subscriber-only Slack channel, priority on our job referrals platform, and so much more! Our courses include detailed lessons, guides, videos, and frameworks to help you ace your interview. Browse our courses at tryexponent.com/courses.',
}, {
  question: 'What is included in the Exponent Slack Channel?',
  answer: 'The Exponent Slack Channel is a private community of tens of thousands of other Exponent members. Our Slack Channel has relevant, fresh information on acing interviews and recent interview experiences shared by candidates like yourself.',
}, {
  question: 'What are priority job referrals?',
  answer: (
    <span>
      As an Exponent member, you get priority in
      {' '}
      <Link className="text-indigo" href="/jobs/referrals" target="_blank">
        our job referral platform
      </Link>
      . This means anytime one of our 400+ referrers looks to refer candidates,
      you will be placed at the top of the list, and you get unlimited referral requests.
    </span>),
}, {
  question: 'Does my membership purchase include coaching?',
  answer: (
    <span>
      If you&rsquo;re interested in interview or career coaching, visit
      {' '}
      <Link className="text-indigo" href="/coaching" target="_blank">Coaching</Link>
      {' '}
      to learn more.
    </span>
  ),
}, {
  question: 'How does the refund policy work?',
  answer: (
    <span>
      If you aren&rsquo;t satisfied with your membership for any reason, reach out to us
      and let us know how we can help. We offer full refunds within 5 days of purchase.
    </span>),
}, {
  question: 'What is your renewal policy?',
  answer: (
    <span>
      Your Exponent membership will renew automatically. You can cancel your plan at
      any time before your renewal date by visiting the
      {' '}
      <Link className="text-indigo" href="/account" target="_blank">account page</Link>
      .
    </span>),
}, {
  question: 'I have a question not answered here.',
  answer: (
    <span>
      Check out our full
      {' '}
      <Link className="text-indigo" href="/support" target="_blank">FAQ list here</Link>
      , or send us an email at
      {' '}
      <Link className="text-indigo" href="mailto:support@tryexponent.com">support@tryexponent.com</Link>
      .
    </span>),
}];

const UpgradeFAQs = ({includeRefundPolicy}) => {
  const questions = includeRefundPolicy ? QuestionsWithRefund : Questions;
  return <FAQs items={questions} includeMetadata />;
};

export default UpgradeFAQs;
